import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { selectRoles, selectToken } from '../../store/reducers/AuthSlice';
import { useAppSelector } from '../../store/store';
import { NotFoundScreen } from '../../screens/NotFoundScreen';

interface Props {
  allowedRoles: string[];
  forbiddenRedirectTo404?: boolean;
}

const RequireAuth: FC<Props> = ({ allowedRoles, forbiddenRedirectTo404 }) => {
  const token = useAppSelector(selectToken);
  const roles = useAppSelector(selectRoles);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!roles?.find((role) => allowedRoles?.includes(role))) {
    if (forbiddenRedirectTo404) {
      return <Navigate to="/404" replace />;
    }

    return <NotFoundScreen />;
  }

  return <Outlet />;
};

export default RequireAuth;
